export default __webpack_public_path__ + "static/webRotator/svg/e3790c9a93fb7c311b6f8a5c0f0e5774.svg";